import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getTestimonials } from "../redux/testimonialSlice";
import useScreenSize from "../hooks/useScreenSize";

const Testimonials = () => {
  const dispatch = useDispatch();
  const { data: testimonials = [], status } = useSelector((state) => state.testimonials);
  const sliderRef = useRef(null);
  const { isMobile } = useScreenSize();
  const [current, setCurrent] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    fade: isMobile,
    cssEase: 'linear',
    afterChange: (idx) => setCurrent(idx)
  };

  useEffect(() => {
    if (status === 'idle') {
      dispatch(getTestimonials());
    }
  }, [dispatch, status]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex align-items-center justify-content-center position-relative mt-3 mb-3">
          <h2 className='heading mb-1 mt-1 mb-md-3 mb-lg-3 mb-xl-3 mt-md-4 mt-lg-4 mt-xl-4'>Testimonials</h2>
        </div>
      </div>

      <div className="col-12 ps-3 pe-3">
        {status === 'loading' && <p>Loading...</p>}
        {status === 'failed' && <p>Failed to load testimonials.</p>}
        {status === 'succeeded' && testimonials.length === 0 && <p>No testimonials available.</p>}
        {status === 'succeeded' && testimonials.length > 0 && (
          <div className="container p-0">
            <Slider ref={sliderRef} {...settings}>
              {testimonials.map((t) => (
                <div className="col-md-12" key={t.tm_id}>
                  <div className='row justify-content-center'>
                    <div className='col-12 col-md-11 col-lg-11'>
                      <div className='testimonial-card'>
                        <div className='row'>
                          <div className='col-12 col-md-12 testimonial-image d-flex align-items-center justify-content-center' style={{ height: 'auto' }}>
                            <img
                              src={t.tm_image || '/images/default-profile.svg'}
                              className='img-fluid'
                              alt={t.tm_name}
                              onError={(e) => { e.target.onerror = null; e.target.src = '/images/default-profile.svg'; }}
                            />
                          </div>
                          <div className='col-12 col-md-12 testimonial-info'>
                            <h3 className='testimonial-title'>{t.tm_name}</h3>
                            {/* <div className='rating-stars'>
                              {[...Array(t.tm_ratings)].map((_, index) => (
                                <span key={index} className='star'>★</span>
                              ))}
                            </div> */}
                            <p className='testimonial-desc'>{t.tm_desc}</p>
                            <div className='d-flex align-items-center justify-content-between testimonial-footer'>
                              <p className='location-text mb-0'><span>{t.tm_location}</span></p>
                              <img src="/images/quote.svg" className='img-fluid quote-icon' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <div className="tm-controls d-none d-sm-none d-md-flex d-lg-flex d-xl-flex pt-4">
              <button
                type="button"
                aria-label="Previous"
                className="tm-arrow tm-prev"
                onClick={() => sliderRef.current?.slickPrev()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M7.66901 12.6703C7.87969 12.4593 7.99802 12.1734 7.99802 11.8753C7.99802 11.5771 7.87969 11.2912 7.66901 11.0803L3.58901 7.00026L7.66901 2.92026C7.77954 2.81726 7.86819 2.69306 7.92968 2.55507C7.99117 2.41707 8.02423 2.2681 8.0269 2.11704C8.02956 1.96599 8.00178 1.81594 7.94519 1.67586C7.88861 1.53578 7.8044 1.40853 7.69757 1.3017C7.59074 1.19487 7.46349 1.11065 7.32341 1.05407C7.18332 0.997492 7.03328 0.969705 6.88223 0.97237C6.73117 0.975035 6.5822 1.0081 6.4442 1.06959C6.3062 1.13107 6.182 1.21973 6.07901 1.33026L1.20401 6.20526C0.993334 6.4162 0.875 6.70213 0.875 7.00026C0.875 7.29838 0.993334 7.58432 1.20401 7.79526L6.07901 12.6703C6.28995 12.8809 6.57588 12.9993 6.87401 12.9993C7.17214 12.9993 7.45807 12.8809 7.66901 12.6703Z" fill="#318B41" />
                </svg>
              </button>

              <div className="tm-dots" role="tablist" aria-label="Testimonials pagination">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`tm-dot ${current === i ? 'active' : ''}`}
                    aria-label={`Go to slide ${i + 1}`}
                    aria-current={current === i ? 'true' : 'false'}
                    onClick={() => sliderRef.current?.slickGoTo(i)}
                  />
                ))}
              </div>

              <button
                type="button"
                aria-label="Next"
                className="tm-arrow tm-next"
                onClick={() => sliderRef.current?.slickNext()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1.33099 12.6703C1.12031 12.4593 1.00198 12.1734 1.00198 11.8753C1.00198 11.5771 1.12031 11.2912 1.33099 11.0803L5.41099 7.00026L1.33099 2.92026C1.22046 2.81726 1.13181 2.69306 1.07032 2.55507C1.00883 2.41707 0.975767 2.2681 0.973102 2.11704C0.970437 1.96599 0.998224 1.81594 1.05481 1.67586C1.11139 1.53578 1.1956 1.40853 1.30243 1.3017C1.40926 1.19487 1.53651 1.11065 1.67659 1.05407C1.81668 0.997492 1.96672 0.969705 2.11777 0.97237C2.26883 0.975035 2.4178 1.0081 2.5558 1.06959C2.6938 1.13107 2.818 1.21973 2.92099 1.33026L7.79599 6.20526C8.00667 6.4162 8.125 6.70213 8.125 7.00026C8.125 7.29838 8.00667 7.58432 7.79599 7.79526L2.92099 12.6703C2.71005 12.8809 2.42412 12.9993 2.12599 12.9993C1.82786 12.9993 1.54193 12.8809 1.33099 12.6703Z" fill="#318B41" />
                </svg>
              </button>
            </div>
            <div className="tm-controls d-flex d-sm-flex d-md-none d-lg-none d-xl-none">
              <button
                type="button"
                aria-label="Previous"
                className="tm-arrow tm-prev"
                onClick={() => sliderRef.current?.slickPrev()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M7.66901 12.6703C7.87969 12.4593 7.99802 12.1734 7.99802 11.8753C7.99802 11.5771 7.87969 11.2912 7.66901 11.0803L3.58901 7.00026L7.66901 2.92026C7.77954 2.81726 7.86819 2.69306 7.92968 2.55507C7.99117 2.41707 8.02423 2.2681 8.0269 2.11704C8.02956 1.96599 8.00178 1.81594 7.94519 1.67586C7.88861 1.53578 7.8044 1.40853 7.69757 1.3017C7.59074 1.19487 7.46349 1.11065 7.32341 1.05407C7.18332 0.997492 7.03328 0.969705 6.88223 0.97237C6.73117 0.975035 6.5822 1.0081 6.4442 1.06959C6.3062 1.13107 6.182 1.21973 6.07901 1.33026L1.20401 6.20526C0.993334 6.4162 0.875 6.70213 0.875 7.00026C0.875 7.29838 0.993334 7.58432 1.20401 7.79526L6.07901 12.6703C6.28995 12.8809 6.57588 12.9993 6.87401 12.9993C7.17214 12.9993 7.45807 12.8809 7.66901 12.6703Z" fill="#318B41" />
                </svg>
              </button>

              <div className="tm-dots" role="tablist" aria-label="Testimonials pagination">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`tm-dot ${current === i ? 'active' : ''}`}
                    aria-label={`Go to slide ${i + 1}`}
                    aria-current={current === i ? 'true' : 'false'}
                    onClick={() => sliderRef.current?.slickGoTo(i)}
                  />
                ))}
              </div>

              <button
                type="button"
                aria-label="Next"
                className="tm-arrow tm-next"
                onClick={() => sliderRef.current?.slickNext()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M1.33099 12.6703C1.12031 12.4593 1.00198 12.1734 1.00198 11.8753C1.00198 11.5771 1.12031 11.2912 1.33099 11.0803L5.41099 7.00026L1.33099 2.92026C1.22046 2.81726 1.13181 2.69306 1.07032 2.55507C1.00883 2.41707 0.975767 2.2681 0.973102 2.11704C0.970437 1.96599 0.998224 1.81594 1.05481 1.67586C1.11139 1.53578 1.1956 1.40853 1.30243 1.3017C1.40926 1.19487 1.53651 1.11065 1.67659 1.05407C1.81668 0.997492 1.96672 0.969705 2.11777 0.97237C2.26883 0.975035 2.4178 1.0081 2.5558 1.06959C2.6938 1.13107 2.818 1.21973 2.92099 1.33026L7.79599 6.20526C8.00667 6.4162 8.125 6.70213 8.125 7.00026C8.125 7.29838 8.00667 7.58432 7.79599 7.79526L2.92099 12.6703C2.71005 12.8809 2.42412 12.9993 2.12599 12.9993C1.82786 12.9993 1.54193 12.8809 1.33099 12.6703Z" fill="#318B41" />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;